/*
 *
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 *
 */

import React from 'react';
import "./InvalidDevice.scss";
import {ExdsButton, ExdsGrid} from '@exds/core';
import {HELP_LINK} from '../../constants/constants';

const InvalidDevice = () => {
  return (<>
    <ExdsGrid
      className="top-bg-invalid-container"
      alignItems="center"
      container
      flexDirection="row"
      justifyContent="flex-start"
    >
      <img className="jpmc-logo-invalid" src="../../assets/images/JPMC_Logo_Standard_Black_RBG.png" alt="JPMC Logo" />
      <ExdsButton
        color="brand"
        iconPosition="leading"
        size="regular"
        text="Help"
        variant="secondary"
        onClick={() => window.open(HELP_LINK, "_blank")}
      />
    </ExdsGrid>
    <div className="invalid-title">Please switch to a different device.</div>
    <div className="invalid-body">This process has been optimized for desktop and tablet devices and cannot be completed on a mobile device</div>
    <br/>
    <div className="invalid-body">If you're seeing this screen on a desktop or tablet, please increase the width of your browser window.</div>
  </>);
};

export default InvalidDevice;
